module.exports = __webpack_public_path__ + "static/media/bariol_medium.560a5861a64f769c63e99eb743bdcc4bfbecf8d58a6fcc27cf9336c03913b03a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_medium.woff
// module id = 2548
// module chunks = 204